import {Helmet} from "react-helmet-async";
import {Button, Container, Stack, TextField, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {config} from "../constant";

export default function AdminPage() {
    const navigate = useNavigate();
    const [showSpinner, setShowSpinner] = useState(false);

    const restore = () => {
        setShowSpinner(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: null
        };
        fetch(`${config.BASE_URL}/restore`, requestOptions)
            .then(response => {
                setShowSpinner(false);
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch(error => {
                const message = 'Erreur dans la restauration';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const restoreArchivePeopleCategories = () => {
        setShowSpinner(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: null
        };
        fetch(`${config.BASE_URL}/restore/archive-people-categories`, requestOptions)
            .then(response => {
                setShowSpinner(false);
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch(error => {
                const message = 'Erreur dans la restauration';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const deleteAllVotes = () => {
        setShowSpinner(true);
        const requestOptions = {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: null
        };
        fetch(`${config.BASE_URL}/votes`, requestOptions)
            .then(response => {
                setShowSpinner(false);
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch(error => {
                const message = 'Erreur dans la suppression des votes';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const deleteAllCategories = () => {
        setShowSpinner(true);
        const requestOptions = {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: null
        };
        fetch(`${config.BASE_URL}/categories`, requestOptions)
            .then(response => {
                setShowSpinner(false);
                console.log(response.status);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch(error => {
                const message = 'Erreur dans la suppression des catégories';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const validationSchema = Yup.object().shape({
        year: Yup.number("Année doit être numérique").transform(value => (Number.isNaN(value) ? undefined : value)).required("Année est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmitArchive = (data) => {
        setShowSpinner(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: null
        };
        fetch(`${config.BASE_URL}/restore/archive/${data.year}`, requestOptions)
            .then(response => {
                setShowSpinner(false);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch(error => {
                const message = 'Erreur dans la restauration d\'une archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    return (
        <>
            <Helmet>
                <title>Admin | Lose Awards</title>
            </Helmet>

            <Typography variant="h4" gutterBottom>
                Administration
            </Typography>

            <Container maxWidth="false">
                <h4 style={{marginBottom: 0}}>Restauration</h4>
                <Stack direction="row" sx={{mt: 2}}>
                    <Button variant="contained" sx={{textTransform: 'none'}} onClick={restore}>
                        Restaurer
                    </Button>
                </Stack>

                <h4 style={{marginBottom: 0}}>Personnes et catégories archive</h4>
                <Stack direction="row" sx={{mt: 2}}>
                    <Button variant="contained" sx={{textTransform: 'none'}} onClick={restoreArchivePeopleCategories}>
                        Restaurer les personnes et catégories archives
                    </Button>
                </Stack>

                <h4 style={{marginBottom: 0}}>Archives</h4>
                <form id="archiveForm" onSubmit={handleSubmit(onSubmitArchive)}>
                    <TextField
                        type="number"
                        margin="dense"
                        id="year"
                        name="year"
                        label="Année"
                        variant="standard"
                        {...register("year")}
                        error={!!errors.year}
                    />
                    <Typography variant="inherit" color="textSecondary">{errors.year?.message}</Typography>
                    <Button type="submit" variant="contained" sx={{textTransform: 'none'}} form="archiveForm">Restaurer l'archive</Button>
                </form>

                <h4 style={{marginBottom: 0}}>Réinitialisation</h4>
                <Stack direction="row" sx={{mt: 2}}>
                    <Button variant="contained" sx={{textTransform: 'none'}} onClick={deleteAllVotes}>
                        Réinitialiser les votes
                    </Button>
                    <Button variant="contained" sx={{textTransform: 'none', ml: 2}} onClick={deleteAllCategories}>
                        Réinitialiser les nominations
                    </Button>
                </Stack>

                {showSpinner && (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="20vh">
                        <CircularProgress />
                    </Box>
                )}
            </Container>

            {/*<Snackbar*/}
            {/*    open={snackbarOpen}*/}
            {/*    autoHideDuration={3000}*/}
            {/*    onClose={() => setSnackbarOpen(false)}*/}
            {/*    message="Restauration effectuée"*/}
            {/*/>*/}
        </>
    );
}